<!-- Header -->
<h3 mat-dialog-title>
	<span *ngIf="addNote || multiAdd"
		translate>
		Add Entry
	</span>
	<span *ngIf="!addNote && !multiAdd"
		translate>
		Edit Entry
	</span>
	<span>
		-
		<ng-container *ngIf="!multiAdd">
			<student-name [firstName]="note.FirstName"
				[middleName]="note.MiddleName"
				[lastName]="note.LastName"
				[nickName]="note.Nickname"></student-name>
			[#{{note.StudentNumber}}]
		</ng-container>
		<ng-container *ngIf="multiAdd">
			<a (click)="viewStudents()">
				Multiple Students
			</a>
		</ng-container>
	</span>
</h3>

<!-- Body -->
<mat-dialog-content>

	<!-- Note Form -->
	<form *ngIf="note"
        style="height: 65vh"
		id="noteForm">

		<!-- Category Picker -->
		<tyl-form-field label="Category"
			[hint]="note.category(categories) && note.category(categories).StudentNotesPopup ? 'This note will appear in the Student Notes popup' : ''"
			hintColor="red"
            style="width: 100%"
			[preventCollapse]="true">
			<mat-select [(ngModel)]="note.SNCID"
				#categoryField
				[required]="true"
				id="modalCategoryField"
				name="Category">
				<mat-option *ngFor="let category of categories"
					[value]="category.Id">
					{{category.Code}}
				</mat-option>
			</mat-select>
		</tyl-form-field>

		<!-- Note Field -->
		<tyl-form-field label="Note"
            style="width: 100%; flex-grow: 1"
			hint="{{note.Note ? 1000 - note.Note.length : 1000}} characters left">
			<textarea matInput
				#noteField
				title="Note"
				[required]="true"
				[(ngModel)]="note.Note"
                maxlength="1000"
				id="modalNoteField"
				style="resize: none; height: 100%"
				name="Note"></textarea>
		</tyl-form-field>

        <!-- Row 3 -->
        <div class="row">

            <!-- Order Field -->
            <tyl-form-field label="Order"
                style="width: 49%"
                [fullWidth]="true">
                <input matInput
                    #orderField
                    title="Order"
                    [(ngModel)]="note.Order"
                    [required]="true"
                    id="modalOrderField"
                    numbers-only
                    name="Order">
            </tyl-form-field>

            <!-- Status Field -->
            <tyl-form-field label="Status"
                style="width: 49%"
                [fullWidth]="true">
                <mat-select [required]="true"
                    #statusField
                    [(ngModel)]="note.Status"
                    id="modalStatusField"
                    name="Status">
                    <mat-option value="Active">
                        Active
                    </mat-option>
                    <mat-option value="Inactive">
                        Inactive
                    </mat-option>
                </mat-select>
            </tyl-form-field>
        </div>

        <!-- Row 4 -->
        <div class="row">

            <!-- Start Date Field -->
            <tyl-datepicker [value]="note.StartDate"
                style="width: 49%"
                [fullWidth]="true"
                (valueChange)="note.StartDate = $event"
                label="Start Date"
                #startDateField></tyl-datepicker>

            <!-- End Date Field -->
            <tyl-datepicker [value]="note.EndDate"
                style="width: 49%"
                [fullWidth]="true"
                (valueChange)="note.EndDate = $event"
				label="End Date"
				#endDateField></tyl-datepicker>
        </div>

		<!-- Display as Bold Checkbox -->
		<tyl-checkbox [(checked)]="note.DisplayBold"
			id="modalDisplayBoldCheckbox">
			Display as Bold
		</tyl-checkbox>

		<!-- Display as Bold Checkbox -->
		<tyl-checkbox [(checked)]="note.ClassroomNote"
			id="modalClassroomNoteCheckbox">
			Classroom Note (will be shown as an alert)
		</tyl-checkbox>
	</form>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">

	<!-- Right Buttons -->
	<div class="footerRight">
		<error-prompt [errorList]="errors"></error-prompt>
		<tyl-button image="save.png"
			label="Save"
			(clickEvent)="save(); validationTrigger.click();"></tyl-button>
		<tyl-button image="Cancel.png"
			label="Cancel"
			(clickEvent)="cancel()"></tyl-button>
	</div>
</mat-dialog-actions>

<!-- Form Validation Trigger -->
<input style="display: none"
	type="submit"
	form="noteForm"
	#validationTrigger>
